/**
 * @file 环形进度条
 * @author liuhanwei
 */
import React from 'react';
import classNames from 'classnames';
import OutlinedCheck from 'acud-icon/lib/icons/OutlinedCheck';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
import { sizeRatioMap, isNumber } from './common';
const CircleProgress = ({ percent = 0, type = 'circle', status, size, strokeColor, iconStrokeColor, infoType = 'text', trailColor, textColor, textSize, labelText, strokeLinecap: customizeStrokeLinecap = 'round', stageWidth: customizeStageWidth, strokeRatio: customizeStrokeRatio, style, className, prefixCls }) => {
    // SVG基础视窗尺寸
    const VIEX_BOX_SIZE = 50;
    // stageWidth取值异常时，将使用size对应的值
    const stageWidth = isNumber(customizeStageWidth) ? customizeStageWidth : '';
    // strokeRatio取值异常时，将使用默认值
    const strokeRatio = isNumber(customizeStrokeRatio) ? customizeStrokeRatio : 10;
    // 根据strokeRatio计算strokeWidth
    const strokeWidth = strokeRatio * VIEX_BOX_SIZE / 100;
    // SVG基础视窗定义
    const viewBoxPath = `0 0 ${VIEX_BOX_SIZE} ${VIEX_BOX_SIZE}`;
    // 环宽度一半的位置到环心的距离
    const radius = VIEX_BOX_SIZE / 2 - strokeWidth / 2;
    // 环路径
    const circlePath = `
        M ${VIEX_BOX_SIZE / 2} ${VIEX_BOX_SIZE / 2}
        m 0 -${radius}
        a ${radius} ${radius} 0 1 1 0 ${2 * radius}
        a ${radius} ${radius} 0 1 1 0 -${2 * radius}
    `;
    // strokeLinecap取值不为square，则全取round
    const strokeLinecap = percent !== 0
        ? customizeStrokeLinecap === 'square' ? 'square' : 'round'
        : null;
    // 最外层容器的类名，将所有状态类名尽可能地代理到这层处理
    const extendedName = classNames(prefixCls, `${prefixCls}-${type}`, `${prefixCls}-${size}`, `${prefixCls}-${status}`, {
        // infoType取值none，则不显示进度信息
        [`${prefixCls}-label-hidden`]: infoType === 'none'
    }, className);
    // 容器样式
    const stageStyles = Object.assign(Object.assign({}, style), { width: `${stageWidth}px`, height: `${stageWidth}px` });
    // 计算圆环周长
    const perimeter = 2 * Math.PI * radius;
    // 填充长度
    const fillLength = percent ? perimeter * (percent - 1) / 100 : 0;
    // 根据进度百分比设置圆环填充样式，-1为了减去linecap多出的长度
    const progressStyles = {
        strokeDasharray: `${fillLength}px, ${perimeter - fillLength}px`,
        strokeDashoffset: 0,
        transition: 'stroke-dasharray 300ms cubic-bezier(.08, .82, .17, 1)'
    };
    // 设置自定义文本样式
    const labelStyles = {
        color: textColor,
        fontSize: `${textSize}px`
    };
    const labelClassNames = classNames(`${prefixCls}-label`, {
        [`${prefixCls}-label-icon`]: infoType === 'icon'
    });
    let ProgressLabel = (<span className={labelClassNames} style={labelStyles}>{labelText}</span>);
    const iconWidth = sizeRatioMap[size] * 12;
    // 若信息类型为图标，在成功和异常时，显示图标
    if (infoType === 'icon') {
        if (status === 'success') {
            ProgressLabel = (<OutlinedCheck className={labelClassNames} width={iconWidth} fill={iconStrokeColor}/>);
        }
        else if (status === 'error') {
            ProgressLabel = (<OutlinedClose className={labelClassNames} width={iconWidth} fill={iconStrokeColor}/>);
        }
    }
    return (<div className={extendedName} style={stageStyles}>
            <div className={`${prefixCls}-trail`}>
                <svg viewBox={viewBoxPath}>
                    <path d={circlePath} stroke={trailColor || 'currentColor'} strokeWidth={strokeWidth} fill="none"/>
                </svg>
            </div>
            <div className={`${prefixCls}-bar`}>
                <svg viewBox={viewBoxPath}>
                    <path d={circlePath} stroke={strokeColor || 'currentColor'} strokeWidth={percent ? strokeWidth : 0} strokeLinecap={strokeLinecap} fill="none" style={progressStyles}/>
                </svg>
            </div>
            <div className={`${prefixCls}-text-wrapper`}>
                {ProgressLabel}
            </div>
        </div>);
};
export default CircleProgress;
